module.exports = __webpack_public_path__ + "videos/video-1025.75b4702.mp4";